/**
 * @file Email Login & Signup (dual mode) container.
 */

import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  accountCreateByEmail,
  accountLogin,
} from '../../graphql/mutations/account';
import { loginSuccess } from '../../actions/auth-actions';
import EmailLoginRegister from '../../components/auth/EmailLoginRegister';
import { withStoreReferralAttributes } from '../../hooks/useStoreReferralAttributes';

const propTypes = {
  onLogin: PropTypes.func,
  onRegister: PropTypes.func,
  emailVerificationRedirectUrl: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
};

const withAccountCreateByEmailMutation = graphql(accountCreateByEmail, {
  props: ({ mutate }) => ({
    accountCreateByEmail: (email, password, redirectUrl) =>
      mutate({
        variables: {
          input: {
            email,
            password,
            email_verification_redirect: redirectUrl,
          },
        },
      }),
  }),
});

const withLoginMutation = graphql(accountLogin, {
  props: ({ mutate }) => ({
    accountLogin: (email, password) =>
      mutate({
        variables: {
          input: { email, password },
        },
      }),
  }),
});

const mapDispatchToProps = {
  loginSuccess,
};

const EmailLoginRegisterContainer = compose(
  withRouter,
  withAccountCreateByEmailMutation,
  withLoginMutation,
  connect(null, mapDispatchToProps),
  withStoreReferralAttributes,
)(EmailLoginRegister);

EmailLoginRegisterContainer.propTypes = propTypes;

export default EmailLoginRegisterContainer;
